@import "../../variables.scss";

.dropzone {
  border: 1px $color-light-grey dashed;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  &_success,
  &:hover {
    background: rgba(33, 150, 243, 0.1);
  }

  &__text {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: $color-dark-grey;
  }

  &__line {
    border-top: 1px $color-info solid;
    width: 45%;
    display: block;
    height: 1px;
  }

  &__btn {
    box-shadow: none !important;
    outline: none;
    background-color: white;
    color: black !important;
    width: 100%;
    @media (min-width: $size-lg) {
      width: auto;
    }
    &:hover {
      background-color: #2196f3 !important;
      color: white !important;
    }
    &:active,
    &:focus {
      background-color: white;
      color: black !important;
    }
  }
  &__link {
    color: $color-bright-blue;
    text-align: center;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}
